module.exports = __webpack_public_path__ + "static/media/groupalia.a8526e59.svg";